"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
function isNotificationImportant(type, message, user, group) {
    switch (type) {
        case bridge_schema_1.NotificationType.Action:
        case bridge_schema_1.NotificationType.Custom:
            return !!(message === null || message === void 0 ? void 0 : message.url) && !!(message === null || message === void 0 ? void 0 : message.button);
        case bridge_schema_1.NotificationType.Join:
            return !!(group === null || group === void 0 ? void 0 : group.name) && !!(user === null || user === void 0 ? void 0 : user.name);
        case bridge_schema_1.NotificationType.JoinRequest:
        case bridge_schema_1.NotificationType.Invite:
        case bridge_schema_1.NotificationType.Sync:
            return true;
        default:
            return false;
    }
}
exports.default = isNotificationImportant;
